import json from '../../package.json';

console.log(`v${json.version}`);
